// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IdeaPermissions } from './ideaPermissions.zod.ts';
import { IndustryBenchmarkOut } from './industryBenchmarkOut.zod.ts';
import { IndustryHint } from './industryHint.zod.ts';
import { IndustryRef } from './industryRef.zod.ts';
import { PersonRef } from './personRef.zod.ts';
import { ResearchOut } from './researchOut.zod.ts';
import { ResearchSummaryOut } from './researchSummaryOut.zod.ts';

export const IdeaDetailOut = zod.object({
  "author": PersonRef,
  "confidence": zod.union([zod.int(),zod.null()]),
  "created_at": zod.iso.datetime({"offset":true}),
  "current_research": zod.union([ResearchOut,zod.null()]),
  "description": zod.string(),
  "disposition": zod.enum(['active', 'parked', 'archived']),
  "history": zod.array(ResearchSummaryOut),
  "id": zod.uuid(),
  "industry": zod.union([IndustryRef,zod.null()]),
  "industry_benchmark": zod.union([IndustryBenchmarkOut,zod.null()]).optional(),
  "industry_hint": zod.union([IndustryHint,zod.null()]).optional(),
  "industry_source": zod.union([zod.enum(['submitter', 'ai', 'admin']),zod.null()]),
  "latest_run": zod.union([ResearchSummaryOut,zod.null()]),
  "permissions": IdeaPermissions,
  "research_status": zod.enum(['queued', 'researching', 'scored', 'failed']),
  "scores": zod.record(zod.string(), zod.union([zod.int(),zod.null()])),
  "source_urls": zod.array(zod.string()),
  "title": zod.string(),
  "total": zod.union([zod.number(),zod.null()]),
  "updated_at": zod.iso.datetime({"offset":true}),
  "verdict": zod.union([zod.enum(['go', 'conditional_go', 'no_go']),zod.null()])
});

export type IdeaDetailOut = zod.input<typeof IdeaDetailOut>;
export type IdeaDetailOutOutput = zod.output<typeof IdeaDetailOut>;
